module.exports = __webpack_public_path__ + "img/4.d51c3062.png";